import { useCallback } from "react";
import { useDraftMode } from "../contexts/DraftModeContext";
import { useHospitalData } from "../contexts/HospitalDataProvider";

/**
 * Asks the cached schedule weeks again after a PTO edit or delete, so their time off shows it before the staff list
 * loads. Every week, as time off can run over several. Not during a draft: its edits live in the cached weeks and a
 * reload would drop them, and ending the draft reloads the weeks anyway.
 */
export const useRefreshScheduleTimeOff = (): (() => Promise<void>) => {
	const { isDraftMode } = useDraftMode();
	const { refreshScheduleCache } = useHospitalData();
	return useCallback(async () => {
		if (!isDraftMode) await refreshScheduleCache({ allWeeks: true });
	}, [isDraftMode, refreshScheduleCache]);
};
